import { useState } from "react";

import { FILTERS } from "../../utils/constants";
import Input from "../Input/Input";
import MultiSelectStyled from "../MultiSelectStyled/MultiSelectStyled";
import { SearchBar } from "../Payment/FilterStyles";
import { SearchButton } from "../SearchButtons/SearchButtons";

export const INITIAL_FILTERS = {
  consignee: "",
  volantesForRequest: [],
  status: [],
};

export function CreditAuthFilters({ onQuery }) {
  const [filters, updateFilters] = useState(INITIAL_FILTERS);

  const onConsigneeChange = (ev) =>
    updateFilters((filters) => ({ ...filters, consignee: ev.target.value }));
  const onStatusChange = (ev) =>
    updateFilters((filters) => ({ ...filters, status: ev.target.value }));

  return (
    <SearchBar hmargin={true}>
      <div className="box">
        <h3>RUC Pagador:</h3>
        <Input
          width="37rem"
          type="text"
          placeholder="HP INC PERÚ"
          value={filters.consignee}
          onChange={onConsigneeChange}
        />
      </div>
      <div className="box">
        <h3>Estado:</h3>
        <MultiSelectStyled
          height="4.5rem"
          width="37rem"
          selectItems={FILTERS.VALIDATION.PAYMENT_STATUS}
          info={filters.status}
          onInfoChange={onStatusChange}
        />
      </div>
      <div className="search-button--container box">
        <SearchButton onClick={() => onQuery(filters)} />
      </div>
    </SearchBar>
  );
}

export function formatFilters(filters) {
  const status =
    filters.status.length > 0
      ? filters.status.map((e) => e.toLowerCase())
      : FILTERS.VALIDATION.PAYMENT_STATUS.map((e) => e.value.toLowerCase());
  const params = {
    payment_status_option: status,
    payer_ruc_name: filters.consignee,
  };
  Object.entries(params).forEach(([key, val]) => {
    if (!val) {
      delete params[key];
    }
  });
  return params;
}
